// src/contexts/RoomFinderContext.js

import React, { createContext, useContext, useState } from "react";

const RoomFinderContext = createContext();

export const RoomFinderProvider = ({ children }) => {
  const [selectedRooms, setSelectedRooms] = useState([]);
  const [bookingData, setBookingData] = useState({});
  const [loaderStart, setLoaderStart] = useState(false);
  const [availableRooms, setAvailableRooms] = React.useState(null);
  const [allRooms, setAllRooms] = React.useState([]);
  const [seeAvailableRoomNumber, setSeeAvailableRoomNumber] =
    React.useState(true);

  return (
    <RoomFinderContext.Provider
      value={{
        selectedRooms,
        setSelectedRooms,
        bookingData,
        setBookingData,
        loaderStart,
        setLoaderStart,
        availableRooms,
        setAvailableRooms,
        allRooms,
        setAllRooms,
        seeAvailableRoomNumber,
        setSeeAvailableRoomNumber,
      }}
    >
      {children}
    </RoomFinderContext.Provider>
  );
};

export const useRoomFinder = () => useContext(RoomFinderContext);
